<!--
 柱状图
-->
<template>
  <div :id="id" :style="echartsStyle"></div>
</template>
<script>
import * as echarts from 'echarts'
import _ from 'lodash'

export default {
  name: 'MultiBarchart',
  props: {
    id: {
      type: String
    },
    echartsStyle: {}
  },
  data () {
    return {
      myChart: null,
    }
  },
  mounted () {
    this.drawLine()
    window.addEventListener('resize', () => this.resize())
  },
  beforeDestroy () {
  },
  methods: {
    // 自适应宽度
    resize () {
      if (this.myChart) {
        this.myChart.resize()
      }
    },
    onAssign (data, source) {
      let optionArg = []
      let tempSource = _.cloneDeep(source)
      data.forEach((item) => {
        optionArg.push(Object.assign(source, item))
        source = _.cloneDeep(tempSource)
      })
      return optionArg
    },
    refreshData (sourcesData, xAxis, yAxis, title, legend, grid) {
      this.myChart.showLoading()
      var option = this.myChart.getOption()
      option.title[0].text = title
      if (legend) {
        Object.assign(option.legend[0], legend)
      }
      if (grid) {
        Object.assign(option.grid[0], grid)
      }
      //获取第一个配置项
      let series0 = _.cloneDeep(option.series[0])
      let xAxis0 = _.cloneDeep(option.xAxis[0])
      let yAxis0 = _.cloneDeep(option.yAxis[0])
      let seriesResult = this.onAssign(sourcesData, series0)
      if (seriesResult.length > 0) {
        option.series = seriesResult
      }
      let xAxisResult = this.onAssign(xAxis, xAxis0)
      if (xAxisResult.length > 0) {
        option.xAxis = xAxisResult
      }
      let yAxisResult = this.onAssign(yAxis, yAxis0)
      if (yAxisResult.length > 0) {
        option.yAxis = yAxisResult
      }
      console.log(option)
      this.myChart.setOption(option)
      this.myChart.resize()
      this.myChart.hideLoading()
    },
    drawLine () {
      // 基于准备好的dom，初始化echarts实例
      this.myChart = echarts.init(document.getElementById(this.id))
      // 绘制图表
      this.myChart.setOption({
        title: {
          text: '',
          show: false,
          left: 'center'
        },
        grid: {
          left: '3%',
          top: '8%',
          right: '4%',
          bottom: '2px',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          valueFormatter: function (value) {
            return value
          }
        },
        legend: {
          orient: 'vertical',
          left: 'right',
          textStyle: {
            color: '#ffffff',  // 设置图例文字颜色为白色
            fontSize: 12
          }
        },
        xAxis: [
          {
            type: 'category',
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              color: '#ffffff',  // 设置x轴标签颜色为白色
              fontSize: 12
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.3)'  // x轴线条颜色
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              formatter: '{value} 人',
              color: '#ffffff',  // 设置y轴标签颜色为白色
              fontSize: 12
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.1)'  // 网格线颜色
              }
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.3)'  // y轴线条颜色
              }
            },
            max: function (value) {
              if (value && value.max) {
                return Math.floor(value.max * 1.1)
              }
            }
          }
        ],
        series: [
          {
            name: '专家人数',
            barWidth: '50%',
            data: [],
            type: 'bar',
            showBackground: true,
            label: {
              show: true,
              formatter: (val) => {
                return val.value === 0 ? '' : val.value+'人'
              },
              color: '#ffffff',  // 设置柱状图标签颜色为白色
              fontSize: 14,
            },
          }
        ]
      })
    }
  }
}
</script>

<style lang="less" scoped>
div[id] {
  position: relative;
}
</style>
